import { TGetProviderAppointmentListInput } from 'types/inbox';
import { Request } from '../request';

export const getConversationsList = (current: number, size: number, clientId?: string) =>
    Request.get({
        url: '/schedule-server/provider/conversations',
        params: clientId ? { current, size, clientId } : { current, size },
    });

export const markReadForConversation = (conversationId: string) =>
    Request.post({ url: '/schedule-server/provider/conversations/read-all-message', params: { conversationId } });

export const getAllUnreadAmount = () => Request.get({ url: '/schedule-server/provider/conversation/gp/unread' }); //provider/conversations/unread

//conversationId=1287_106527&pageSize=20&cursor
export type TGetConversationMessageList = {
    conversationId: string;
    size?: number;
    cursor?: string;
};

export const getConversationMessageList = (params: TGetConversationMessageList) =>
    Request.get({ url: '/schedule-server/provider/conversations/messages', params: { ...params } });

type TSendMessage = {
    providerId: number | string;
    clientId: number | string;
    message?: string;
    fileId?: number;
    conversationId?: string;
};

export const sendMessage = (param: TSendMessage) =>
    Request.post({
        url: '/schedule-server/provider/conversations/sendMessage',
        params: param,
        overrideProviderId: param.providerId,
    });

export const getOrCreateConversation = (providerId: number, clientId: number) =>
    Request.post({ url: '/schedule-server/provider/conversations', params: { providerId, clientId } });

export const getProviderAppointmentList = (data: TGetProviderAppointmentListInput) =>
    Request.post({
        url: `/schedule-server/client/appointment/${data.clientId}/list`,
        params: data,
        disableErrorNote: true,
    });

export const getProviderAppointmentListCount = (clientId: number) =>
    Request.get({ url: `/schedule-server/prospect/appointment/counts/${clientId}` });

export const sendReminder = (
    clientId: number,
    action: 'PROVIDER_PATIENT_INVITATION_WHEN_NOT_SENT' | 'PROVIDER_PATIENT_ONBOARDING_IN_PROGRESS_REMINDER',
) =>
    Request.post({
        url: '/schedule-server/provider/reminder/send',
        params: {
            clientId,
            action,
        },
    });
